import { render, staticRenderFns } from "./customwidget.vue?vue&type=template&id=1e61a7b7&"
import script from "./customwidget.vue?vue&type=script&lang=ts&"
export * from "./customwidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e61a7b7')) {
      api.createRecord('1e61a7b7', component.options)
    } else {
      api.reload('1e61a7b7', component.options)
    }
    module.hot.accept("./customwidget.vue?vue&type=template&id=1e61a7b7&", function () {
      api.rerender('1e61a7b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/customwidget.vue"
export default component.exports